/**
 * Internal domain model for the current user's permission grants.
 * Both legacy (v2) and v3 paths normalize into this shape.
 * Property names are provisional camelCase until the v3 /me grant enum is confirmed with BE.
 */
export interface PermissionsGrants {
  /** False when me.teams is empty — user has no GM team assignment. */
  hasAppAccess: boolean;

  // Budgets
  viewInstitutionalNil: boolean;
  editInstitutionalNil: boolean;
  viewThirdPartyNil: boolean;
  editThirdPartyNil: boolean;
  viewScholarships: boolean;
  editScholarships: boolean;

  // Agreements
  viewRevShareAgreements: boolean;
  editRevShareAgreements: boolean;
  viewScholarshipAgreements: boolean;
  editScholarshipAgreements: boolean;

  // Payments (canSendPayments is intentionally excluded — wallet state, not a permission)
  viewPayments: boolean;
  editPayments: boolean;

  // Agents
  viewAgents: boolean;
  editAgents: boolean;

  // Earnings Benchmarks
  viewEarningsBenchmarks: boolean;

  // Roster (viewRoster is derived; editRoster is independently grantable in v3)
  viewRoster: boolean;
  editRoster: boolean;

  // Derived
  canViewTotalEarnings: boolean;
  viewSettingsScholarships: boolean;
  viewContractTemplates: boolean;
  viewSettingsNotifications: boolean;
  viewUserPermissions: boolean;

  isSuperAdmin: boolean;
}

export function createEmptyPermissionsGrants(): PermissionsGrants {
  return {
    hasAppAccess: false,
    viewInstitutionalNil: false,
    editInstitutionalNil: false,
    viewThirdPartyNil: false,
    editThirdPartyNil: false,
    viewScholarships: false,
    editScholarships: false,
    viewRevShareAgreements: false,
    editRevShareAgreements: false,
    viewScholarshipAgreements: false,
    editScholarshipAgreements: false,
    viewPayments: false,
    editPayments: false,
    viewAgents: false,
    editAgents: false,
    viewEarningsBenchmarks: false,
    viewRoster: false,
    editRoster: false,
    canViewTotalEarnings: false,
    viewSettingsScholarships: false,
    viewContractTemplates: false,
    viewSettingsNotifications: false,
    viewUserPermissions: false,
    isSuperAdmin: false,
  };
}
